import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ProfileComponent } from './profile.component';
import { ProfileFormTemplateDetailComponent } from './profile-form-template-detail/profile-form-template-detail.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CtDatatableModule, CtFormGeneratorModule, CtModelModule } from '@ctsolution/ct-framework';

// Material Legacy imports
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { ChangePasswordCardComponent } from '../change-password-card/change-password-card.component';
import { ChangePasswordCardModule } from '../change-password-card/change-password-card.module';

const routes: Routes = [
  {
    path: '',
    component: ProfileComponent
  },
  {
    path: 'form-template/:id',
    component: ProfileFormTemplateDetailComponent
  }
];

@NgModule({
  declarations: [
    ProfileComponent,
    ProfileFormTemplateDetailComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule, // <-- FONDAMENTALE per reactive forms
    CtModelModule,
    CtFormGeneratorModule,
    CtDatatableModule,

    // Material Legacy
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatProgressSpinnerModule,
    ChangePasswordCardModule
  ]
})
export class ProfileModule { }
